<template>
    <div class="xc">
      <meta-info>
        <title>Wireless Connect - inte-QT</title>
        <meta name="title" content="Wireless Connect - inte-QT" />
        <meta
          name="description"
          content="Networks that use 3G, 4G Long Term Evolution (LTE), and 5G mobile broadband technologies."
        />
        <link rel="canonical" href="https://www.inte-qt.com/services/wireless-connect" />
      </meta-info>
  
      <img
        src="@/assets/images/nEmUr0i.jpg"
        alt="Wireless Connect Banner"
        class="banner-img banner-img__black"
      />
      <div class="xc__gradient"></div>
      <h1 class="banner-img__header text-center">Wireless Connect</h1>
  
      <div class="container-fluid">
        <div class="container" align="justify">
          <div class="b_read">
            <p class="xc__subtitle text-center">
              Delivering the new era of wireless connectivity, Plug and Play
              3G/4G/5G and wireless LTE solutions.
            </p>
  
            <h3 class="xc__q">What is Wireless Connect (XC) and its Importance?</h3>
            <p>
              Networks that use 3G, 4G Long Term Evolution (LTE), and 5G mobile
              broadband technologies.
            </p>
            <p>
              It offers global coverage, security, and other capabilities
              to organizations for uninterrupted internet access—
              especially for advanced IoT (Internet of Things) applications
              and automation.
            </p>
  
            <h3 class="xc__q">An end-to-end, fully managed Global Wireless Connect</h3>
            <p>
              We have relations with carriers and managed service partners in more than
              <strong>190+ countries</strong> across the world, giving us unmatched presence
              to provide wireless connect (XC) and LTE solutions with best-in-segment SLAs.
            </p>
  
            <h3 class="xc__q">
              Enabling Network to hard-to-reach locations using SIM's XC connectivity
            </h3>
            <ol>
              <li><p>Quick deployments with High-capacity Bandwidth</p></li>
              <li><p>Uninterrupted Connectivity with minimal disruptions</p></li>
              <li><p>SIM device pairing with specific devices</p></li>
              <li><p>Dedicated portal integration for optimizing tariffs</p></li>
              <li><p>Secure, optimal performance wireless connectivity solutions</p></li>
            </ol>
  
            <h3 class="xc__q">What makes inte-QT unique</h3>
            <ol>
              <li><p>Unmatched Fast delivery</p></li>
              <li><p>Global presence with Local expertise</p></li>
              <li><p>Proactive monitoring by NSOC team <strong>24*7*365</strong></p></li>
              <li><p>Standardized Process</p></li>
            </ol>
          </div>
        </div>
      </div>
  
      <div class="xc__space">
        <ConnectivitySolutions />
      </div>
  
      <div class="my-5 g-5">
        <h2 class="mt-5 text-center center-header mx-auto">
          We help not one, but many companies.
        </h2>
        <CarouselIndu />
      </div>
  
      <TestimonialCarousel />
      <GetInTouch />
    </div>
  </template>
  
  <script setup>
  import { onMounted } from 'vue'
  import { useHead } from '@vueuse/head'
  
  import CarouselIndu from '@/components/CarouselIndu.vue'
  import ConnectivitySolutions from '@/components/ConnectivitySolutions.vue'
  import GetInTouch from '@/components/GetInTouch.vue'
  import TestimonialCarousel from '@/components/TestimonialCarousel.vue'
  
  onMounted(() => {
    window.scrollTo(0, 0)
  })
  
  useHead({
    title: 'Wireless Connect - inte-QT',
    meta: [
      {
        name: 'description',
        content:
          'Networks that use 3G, 4G Long Term Evolution (LTE), and 5G mobile broadband technologies.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.inte-qt.com/services/wireless-connect',
      },
    ],
  })
  </script>
  
  <style scoped>
  
  </style>
  